import { isMessageDescriptor } from '@salsita-ai/platform-common/utils';
import { TopMaterial } from './__generated/model/index.js';
/**
 * Generates a full localized product description by combining the description fields.
 */ export const resolveProductDescription = ($table, i18n)=>{
    const resolveLocalizable = (message)=>isMessageDescriptor(message) ? i18n._(message) : message;
    const { $legs, $top, $descriptionHeight } = $table;
    const { $descriptionDimensions, $descriptionEdgeFinish, $descriptionFenixVariant, $descriptionMaterial, $descriptionShape, $descriptionTopColor, $descriptionTopFinish, material } = $top;
    const { $descriptionLegsColor, $descriptionLegOffset, $descriptionLegStyle, $descriptionLegThickness } = $legs;
    const combinedMaterialDescription = material === TopMaterial.Fenix ? `${resolveLocalizable($descriptionMaterial)} ${resolveLocalizable($descriptionFenixVariant)}` : resolveLocalizable($descriptionMaterial);
    const firstLine = [
        resolveLocalizable($descriptionShape),
        combinedMaterialDescription,
        $descriptionDimensions,
        resolveLocalizable($descriptionHeight)
    ].filter((description)=>typeof description === 'string' && description.length > 0).join(', ');
    const secondLine = [
        resolveLocalizable($descriptionTopColor),
        resolveLocalizable($descriptionTopFinish),
        resolveLocalizable($descriptionEdgeFinish)
    ].filter((description)=>typeof description === 'string' && description.length > 0).join(', ');
    const thirdLine = [
        $descriptionLegStyle,
        resolveLocalizable($descriptionLegsColor),
        resolveLocalizable($descriptionLegOffset),
        resolveLocalizable($descriptionLegThickness)
    ].filter((description)=>typeof description === 'string' && description.length > 0).join(', ');
    return [
        firstLine,
        secondLine,
        thirdLine
    ].join('\n');
};

//# sourceMappingURL=product-description.js.map